<script setup lang="ts">
import type { GenericParameters } from "~/core/models/GenericParameters.type";
import type LxcError from "~/core/models/LxcError.class";
import type { UseFetchResponse } from "~/core/models/UseFetchResponse.interface";
import { OrganizationType } from "~/modules/organization/models/OrganizationType.enum";
import AffiliationChildrenList from "~/modules/relation/affiliation/components/AffiliationChildrenList.vue";
import type { RelationEntity } from "~/modules/relation/models/RelationEntity.interface";

const props = defineProps<
  GenericParameters & {
    organizationType?: OrganizationType;
    parentAffiliation?: RelationEntity;
    errorParentAffiliation?: LxcError;
    fetchAffiliationChildrenResponse?: UseFetchResponse<RelationEntity>;
  }
>();
</script>

<template>
  <relations-container>
    <h4 class="mb-5 text-gray-900">
      {{ $t("administration.relations.affiliations.title") }}
    </h4>

    <div v-if="organizationCode">
      <affiliation-parent
        :organization-code="organizationCode"
        :parent-affiliation="parentAffiliation"
        :error="errorParentAffiliation"
      />
    </div>

    <div v-if="organizationType !== OrganizationType.OPERATOR">
      <div class="mb-4">
        {{ $t("administration.relations.affiliations.childrenEntities.title") }}
      </div>

      <affiliation-children-list v-bind="props" />
    </div>
  </relations-container>
</template>
